export default __webpack_public_path__ + "static/media/img-9.a32ee362.jpg";